import React from 'react';

export const ReadBooksContext = React.createContext({
  setReadBooks: (readBooks) => {},
  readBooks: {},
});
